import * as React from "react";
import { useState, useEffect } from "react";
import { ActionHandlerFunction } from "@preveil-api";
import { DragEventTypes, TreeItem } from "src/common";
import TreeFile from "./TreeFile.component";
import TreeFolder from "./TreeFolder.component";

type TreeProps = {
  data: TreeItem[];
  readonly?: boolean;
  active?: string;
  className?: string;
  fetching_children?: boolean;
  drive?: boolean;
  show_create_folder?: boolean;
  empty_tooltip?: string;
  drag_events?: DragEventTypes[];
  handleAction: ActionHandlerFunction;
};

type TreeRecursiveProps = TreeProps & {
  creating_folder_id?: string;
  onSetCreating?: (id: string | undefined) => void;
};

function TreeRecursive(props: TreeRecursiveProps) {
  const { active, data, readonly, fetching_children, drive, empty_tooltip, drag_events, show_create_folder, creating_folder_id, onSetCreating, handleAction } = props;

  return <>
    {
      !!data &&
      data.map((item: TreeItem, i: number) => {
        // if its a file render <TreeFile /> -> TO DO If needed
        if (item.type === "file") {
          return <TreeFile key={`file_${i}_${item.id}`} file={item}
            handleAction={handleAction} />;
        } else {
          return <TreeFolder key={`folder_${i}_${item.id}`} folder={item}
            active={active === item.id}
            readonly={readonly}
            fetching_children={fetching_children}
            drive={drive}
            empty_tooltip={empty_tooltip}
            show_create_folder={show_create_folder}
            creating_folder_id={creating_folder_id}
            onSetCreating={onSetCreating}
            drag_events={drag_events}
            handleAction={handleAction}  >
            {
              !!item.children &&
              <TreeRecursive
                data={item.children}
                handleAction={handleAction}
                readonly={readonly}
                active={active}
                fetching_children={fetching_children}
                drive={drive}
                empty_tooltip={empty_tooltip}
                show_create_folder={show_create_folder}
                creating_folder_id={creating_folder_id}
                onSetCreating={onSetCreating}
                drag_events={drag_events} />
            }
          </TreeFolder>;
        }
      })
    }
  </>;
};

function Tree(props: TreeProps) {
  const { data, readonly, active, className, fetching_children, drive, empty_tooltip, show_create_folder, drag_events, handleAction } = props;
  const [creating_folder_id, setCreatingFolderId] = useState<string | undefined>();

  // Description: Close any open CreateFolderRow when clicking outside the tree or on
  // a non-create-folder element within it. Clicks on .add-folder-btn are excluded
  // because that button's own onMouseDown handles opening the new row.
  useEffect(() => {
    if (!show_create_folder) return;
    const handleMouseDown = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.closest(".create-folder-row")) return;
      if (target.closest(".add-folder-btn")) return;
      setCreatingFolderId(undefined);
    };
    document.addEventListener("mousedown", handleMouseDown);
    return () => document.removeEventListener("mousedown", handleMouseDown);
  }, [show_create_folder]);

  return <div className={`tree${!!className ? ` ${className}` : ""}`}>
    <TreeRecursive
      data={data}
      handleAction={handleAction}
      readonly={readonly}
      active={active}
      fetching_children={fetching_children}
      drive={drive}
      empty_tooltip={empty_tooltip}
      show_create_folder={show_create_folder}
      creating_folder_id={creating_folder_id}
      onSetCreating={setCreatingFolderId}
      drag_events={drag_events} />
  </div>;
}

export default React.memo(Tree);
